<template>
  <b-modal
    id="SaveImageModal"
    v-model="showModal"
    title="Do you want to upload these images?"
    size="lg"
  >
    <b-list-group>
      <SaveImageItem
        v-for="key in keys"
        :key="key"
        :image="previews[key]"
        :disabled="uploading"
      />
    </b-list-group>

    <template v-slot:modal-footer="{hide}">
      <SaveImageButton
        :disabled="uploading"
        @click="hide"
      >
        Cancel
      </SaveImageButton>
      <SaveImageButton
        variant="danger"
        :disabled="uploading"
        @click="discardAll()"
      >
        Discard All
      </SaveImageButton>
      <SaveImageButton
        variant="primary"
        :disabled="uploading"
        :loading="uploading"
        @click="uploadAll()"
      >
        Upload All
      </SaveImageButton>
    </template>
  </b-modal>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import SaveImageItem from '@/components/builder/images/SaveImageItem.vue'
import SaveImageButton from '@/components/builder/images/SaveImageButton.vue'

const components = {
  SaveImageItem, SaveImageButton,
}

// eslint-disable-next-line no-use-before-define
@Component<SaveImageModal>({
  components,
  watch: {
    noPreviewsRemaining (value) {
      if (value && this.showModal && !this.uploading) {
        this.hideAndSave()
      }
    },
  },
})
export default class SaveImageModal extends Vue {
  uploading = false
  showModal = false

  get previews () {
    return this.$typedStore.primary.entities.images.previews
  }

  get keys () {
    return Object.keys(this.previews)
  }

  get noPreviewsRemaining () {
    return this.keys.length === 0
  }

  discardAll () {
    this.$typedStore.primary.entities.images.clearPreviews()
    this.hideAndSave()
  }

  async uploadAll () {
    this.uploading = true
    await this.$typedStore.primary.entities.images.saveAllImages()
    this.hideAndSave()
    this.uploading = false
  }

  hideAndSave () {
    this.$root.$emit('save-version')
    this.$bvModal.hide('SaveImageModal')
  }
}

</script>
